import React, {
  useState,
  FunctionComponent, useEffect,
} from 'react';
import './pinSingleInput.scss';
import { IPinCode } from '../../types/pin';

export const PinSingleInput: FunctionComponent<IPinCode> = ({
  handleInput,
  className,
  length = 6,
}) => {
  const classBase = 'custom-single-input-pin';
  const [value, setValue] = useState<string>('');

  useEffect(() => {
    if (handleInput) {
      handleInput(value);
    }
  }, [value]);

  const handleOnChange = (ev: any) => {
    setValue(ev);
  };

  return (
    <div className={`${classBase} d-flex justify-content-center`}>
      <input
        className={`
            f-s-16 width-12 pin-input
            ${className || ''}
          `}
        value={value}
        placeholder="000 000"
        onChange={(ev) => handleOnChange(ev.target.value)}
        autoComplete="one-time-code"
        type="text"
        maxLength={length}
        data-testid={classBase}
        inputMode="numeric"
        pattern="[0-9]*"
      />
    </div>
  );
};
